<div class="server-error">
  <h1>Neue Sohlen in Arbeit - bald läuft's wieder!</h1>
  <p>Der Shop ist im Moment nur eingeschränkt verfügbar. Bitte versuche es in einigen Minuten noch einmal.</p>
</div>
